import netsIncomingCalls from './nets-incoming-calls';

export default angular
  .module('app.incomingCalls', [])
  .component('netsIncomingCalls', netsIncomingCalls);
